import { FinanceRoutesRegex } from '#pplx/frontend/apps/ask/routing/routeRegexes.js';
import { usePathname } from '#pplx/frontend/router/usePathname.js';
import { useMemo } from 'react';
const SupportedIndexRoutes = [
    'earnings',
    'crypto',
    'screener',
    'politicians',
    'news',
    'watchlist',
    'portfolio',
    'predictions',
    'lists',
    'gallery',
    'workflows',
];
export const parseFinanceRoute = (pathname) => {
    if (!pathname) {
        return {
            type: null,
        };
    }
    const regex = new RegExp(FinanceRoutesRegex);
    const match = pathname.match(regex);
    if (!match) {
        return {
            type: null,
        };
    }
    // /finance → market section
    if (!match[2]) {
        return {
            type: 'index',
            section: 'market',
        };
    }
    // /finance/earnings, /finance/crypto, etc → index sections
    if (SupportedIndexRoutes.includes(match[2])) {
        return {
            type: 'index',
            section: match[2],
            uuid: match[3],
            sectionUuid: match.length > 3 ? match[3] : undefined,
        };
    }
    // /finance/AAPL or /finance/AAPL/financials → asset
    const asset = {
        type: 'asset',
        uuid: match[2],
        section: match[3] ?? 'index',
        sectionUuid: match.length > 4 ? match[4] : undefined,
    };
    return asset;
};
export const useFinanceRoute = () => {
    const pathname = usePathname();
    return useMemo(() => parseFinanceRoute(pathname), [pathname]);
};
//# sourceMappingURL=routes.js.map